import React from "react";
import { Link } from "react-router-dom";
import { BsDot, BsFillShareFill } from "react-icons/bs";
import Agent from "../../molecules/Agent/Agent";
import Footer from "../../molecules/Footer/Footer";
import Foot from "../../molecules/Foot/Foot";

import "./Agents.css";
import Info from "../../atoms/Info/Info";

const Agents = () => {
  const decor = {
    textDecoration: "none",
  };

  return (
    <div className="listing-wrapper">
      <div className="listing-container">
        <div className="listing-heading">
          <div className="inner">
            <h4>List of our Agents</h4>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut nec
              tincidunt arcu, sit amet fermentum sem.
            </p>
          </div>
        </div>
        <div className="trry">
          <div className="wrap-mini">
            <div className="list-starter">
              <div className="home-list">
                <div className="dot">
                  <Link style={decor} to="/">
                    <li className="home">Home</li>
                  </Link>{" "}
                  <BsDot className="dotted-icon" />
                </div>
                <div className="dot">
                  <Link style={decor} to="/agents">
                    <li className="home">Agents</li>
                  </Link>{" "}
                  <BsDot className="dotted-icon" />
                </div>
              </div>
              <div className="share">
                <BsFillShareFill className="share-icon" />
                <p className="share-text">Share</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="home-bg">
        <div className="home-section">
          <Agent />
        </div>
      </div>
      <Info />
      <div className="section-footer">
        <div className="inner-footer">
          <Footer />
        </div>
      </div>
      <div className="mini-footer">
        <div className="mini-footerr">
          <Foot />
        </div>
      </div>
    </div>
  );
};

export default Agents;
